<template>
  <component :is="component" v-bind="$attrs">
    {{ formattedAmount }}
    {{ !hideUnit ? $t(`currency.${$config.currency.display}`) : '' }}
  </component>
</template>

<script>
import { converter } from '@/utils/currency-helper'

export default {
  name: 'BrbCurrencyDisplay',
  props: {
    amount: {
      type: [Number, String],
      required: true
    },
    component: {
      type: String,
      default: 'span'
    },
    hideUnit: Boolean
  },
  computed: {
    formattedAmount() {
      return converter(this.amount)
    }
  }
}
</script>
